import React from 'react'
import ChatPopup from '../../app/components/chat/ChatPopup'
import { Link, useLocation } from 'react-router-dom'



function CustomerFooter() {

  const location = useLocation();

  const isComplaintsActive = () => {
    return location.pathname.startsWith('/complaint');
  };

  const isNearMeActive = () => {
    return location.pathname.startsWith('/nearme');
  };

  const isEPFPortal = () =>{
    return localStorage.portalId.startsWith('epf-');
  }


  return (
    <footer className="fixed-bottom bg-dark text-white py-2 border-top shadow-sm rounded-top">
      <div className="container">
        <div className="row justify-content-evenly align-items-center">
          <div className="col-auto text-center">
            <Link to="/chatbot" className={location.pathname=="/chatbot"? "text-white text-decoration-none" :"text-secondary text-decoration-none"}>
              {/* Small Screen Content */}
              <div className="d-block d-md-none">
                <i className="fas fa-comments fa-1x"></i>
                <div className="mt-1 small">Ask Me</div>
              </div>

              {/* Large Screen Content */}
              <div className="d-none d-md-block">
                <i className="fas fa-comments fa-2x"></i>
                <div className="mt-1">Ask Me</div>
              </div>
            </Link>
          </div>

          {!isEPFPortal() &&
          <div className="col-auto text-center">
            <Link to="/complaint" className={isComplaintsActive() ? "text-white text-decoration-none" :"text-secondary text-decoration-none"}>
              <div className="d-block d-md-none">
                <i className="fas fa-person-circle-question fa-1x"></i>
                <div className="mt-1 small">Complaints  </div>
              </div>
              <div className="d-none d-md-block">
                <i className="fas fa-person-circle-question fa-2x"></i>
                <div className="mt-1">Complaints</div>
              </div>
            </Link>
          </div>
          }

          <div className="col-auto text-center">
            <Link to="/emergency" className={location.pathname=="/emergency"? "text-white text-decoration-none" :"text-secondary text-decoration-none"}>
              <div className="d-block d-md-none">
                <i className="fas fa-bolt fa-1x"></i>
                <div className="mt-1 small">Emergency</div>
              </div>
              <div className="d-none d-md-block">
                <i className="fas fa-bolt fa-2x"></i>
                <div className="mt-1">Emergency</div>
              </div>
            </Link>
          </div>

          <div className="col-auto text-center">
          <Link to="/about" className={location.pathname=="/about"? "text-white text-decoration-none" :"text-secondary text-decoration-none"}>
              <div className="d-block d-md-none">
                <i className="fas fa-info-circle fa-1x"></i>
                <div className="mt-1 small">About</div>
              </div>
              <div className="d-none d-md-block">
                <i className="fas fa-info-circle fa-2x"></i>
                <div className="mt-1">About</div>
              </div>
            </Link>
          </div>

          
        </div>
      </div>
    </footer>

  )
}

export default CustomerFooter